export default "__VITE_ASSET__BrEkBolu__"